module.exports = __webpack_public_path__ + "img/banner_new_1.ae6c25dc.jpg";